import type * as Rx from 'rxjs'
import type { Unit } from '../Unit'
import type { FieldsValue } from '../formBuilder'
import type { Validator } from './Validator'
import type { ValidatorMapResult } from './ValidatorResult'
import { ValidatorRunner } from './ValidatorRunner'

export class ValidatorSubscriber {
    private validatorSubscriptions = {} as { [name: string]: Rx.Subscription | undefined }

    private doSubscribe(
        value: Unit.UnionFields['v'],
        data: Unit.UnionFields['d'],
        fields: FieldsValue,
        validators: Validator.validatorsBuilded,
        onComplete: (mapResult: ValidatorMapResult) => void
    ) {
        return new ValidatorRunner(validators).validate(value, data, fields).subscribe(onComplete)
    }

    public subscribeValidator(
        name: string,
        value: Unit.UnionFields['v'],
        data: Unit.UnionFields['d'],
        fields: FieldsValue,
        validators: Validator.validatorsBuilded,
        onComplete: (mapResult: ValidatorMapResult) => void
    ) {
        const validatorSubscription = this.validatorSubscriptions[name]

        if (typeof validatorSubscription !== 'undefined' && !validatorSubscription.closed) {
            validatorSubscription.unsubscribe()
        }

        this.validatorSubscriptions[name] = this.doSubscribe(value, data, fields, validators, onComplete)
    }

    public unscribeAll() {
        Object.values(this.validatorSubscriptions).map(s => s && s.unsubscribe())
    }
}
